((angular) => {
  'use strict';

  angular
    .module('Pages')
    .controller('Pages.perfilCtrl', [
      '$q',
      'Loader',
      '$location',
      'Toast',
      'jwtHelper',
      '$routeParams',
      '$window',
      'AuthService',
      'ParticipantService',
      'CompanyService',
      'PositionService',
      'PositionTypeService',
      PerfilCtrl,
    ]);

  function PerfilCtrl(
    $q,
    Loader,
    $location,
    Toast,
    jwtHelper,
    $routeParams,
    $window,
    authService,
    participantService,
    companyService,
    PositionService,
    PositionTypeService
  ) {
    this.participant = {};
    this.isGuest = false;
    let participantPromise = null;
    this.newPosition = false;

    if ($location.search().t) {
      this.isGuest = true;
      const token = $location.search().t;
      this.user = jwtHelper.decodeToken(token);
      participantPromise = $q.resolve({
        name: this.user.name,
        cpf: this.user.cpf,
        guest_company: this.user.company_description,
        credential_name: this.user.name.substring(0, 20),
        position: this.user.position,
        position_type_id: this.user.position_type_id,
        enterprise_mail: this.user.email,
        personal_phone: this.user.phone,
        event_id: this.user.event_id,
        company_id: this.user.company_id || '',
      });
    } else {
      participantPromise = Loader.add(participantService.current());
    }

    if (!this.user && !authService.isLoggedIn()) {
      $location.path('/');
      return;
    }

    this.promise = Loader.add(
      $q.all([
        participantPromise,
        companyService.list(),
        PositionService.list(),
        PositionTypeService.list(),
      ])
    )
      .then(([participant, companies, positions, position_type]) => {
        this.participant = participant;
        this.participant.company = companies.filter(
          (c) => c.id === participant.company_id
        )[0];
        this.positions = positions;
        this.position_type = position_type;

        this.participant.asset =
          { filename: participant.avatar ? participant.avatar : null } || null;
      })
      .catch((err) => Toast.httpHandler(err));

    this.upload = (result) => {
      this.removeUpload();
      this.participant.asset = {
        filename: result.filename,
        base64: result.base64,
      };
    };

    this.removeUpload = () => {
      this.participant.asset = null;
    };

    this.hasFile = () => {
      return this.participant.asset && this.participant.asset.filename
        ? true
        : false;
    };

    this.save = () => {
      if (!this.participant.asset.filename) {
        return Toast.show('Foto é obrigatória', 'error');
      }

      return Loader.add(participantService.save(this.participant))
        .then(() => {
          Toast.show('Dados atualizados', 'success');

          if (this.isGuest) {
            $location.path('/dashboard');
          }
        })
        .then(
          PositionService.list().then((positions) => {
            this.positions = positions;
          })
        )
        .catch((err) => Toast.httpHandler(err));
    };

    this.editPosition = () => {
      this.newPosition = true;
    };

    this.cancelEditPosition = () => {
      this.newPosition = false;
    };
  }
})(angular);
